import React, { FunctionComponent, useMemo } from 'react';

import cn from 'classnames';
import { useSelector } from 'react-redux';

import { getSocialLinks } from '../../../../shared/helpers/external-links';
import { i18n } from '../../../../shared/helpers/i18n';
import ButtonsWrapper from './buttons-wrapper';
import css from './styles.css';
import { ShareButtonProps, ShareButtonsBlockProps } from './types';

const ShareButtons: FunctionComponent<ShareButtonsBlockProps> = ({ iconClassName, ...props }) => {
    const { telegram, whatsapp, slack, messenger } = useSelector(getSocialLinks);
    const buttonsSettings: ShareButtonProps[] = useMemo(
        () => [
            {
                iconName: 'telegramShare',
                href: telegram,
                title: i18n('call', 'share-link-tg'),
                testId: 'share-link-tg-button',
            },
            {
                iconName: 'whatsappShare',
                href: whatsapp,
                title: i18n('call', 'share-link-whatsapp'),
                testId: 'share-link-whatsapp-button',
            },
            {
                iconName: 'messengerShare',
                href: messenger,
                title: i18n('call', 'share-link-messenger'),
                testId: 'share-link-messenger-button',
            },
            {
                iconName: 'slackShare',
                href: slack,
                title: i18n('call', 'share-link-slack'),
                testId: 'share-link-slack-button',
            },
        ],
        [telegram, whatsapp, slack, messenger]
    );

    const iconClasses = cn(css.shareButtonIcon, iconClassName);

    return <ButtonsWrapper buttonsSettings={buttonsSettings} iconClassName={iconClasses} {...props} />;
};

export default ShareButtons;
